import React, { useState } from 'react';

import * as Styled from './styles';

const mainNavItems = [
  {
    title: 'Home',
    slug: '/'
  },
  {
    title: 'Events',
    slug: '/event'
  },
  {
    title: 'Community',
    slug: '/community'
  },
  {
    title: 'Blogs',
    slug: '/blog'
  },
  {
    title: 'About Us',
    slug: '/aboutus'
  }
];

const MainNav = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="" open={open}>
        {mainNavItems.map((item, index) => (
          <Styled.MainNavItem
            key={`nav-item-${index}`}
            to={item.slug}
            activeClassName="active"
            whileTap={{ scale: 0.9 }}
          >
            {item.title}
          </Styled.MainNavItem>
        ))}
      </div>
      <Styled.ToogleMainNav open={open} onClick={() => setOpen(!open)}>
        <span />
        <span />
        <span />
      </Styled.ToogleMainNav>
    </>
  );
};

export default MainNav;
